// this file sets the top margin on <main> if there's a sticky header
const $ = require('jquery');
//const forEach = require('lodash.foreach');
const { $window } = require('../lib/selectors');
const { menuBreakpoint } = require('../lib/widths');

const $stickyHeader = $('.site-header.sticky');
const $mainSection = $('main.main-content');

let stuck = false;
let headerHeight;
let belowBreakpoint = false;

// add event listeners if menu is sticky
if ($stickyHeader.length) {
  console.log('has sticky');
  stickMenuCheck(); // fire immediately
  document.addEventListener('scroll', stickMenuCheck, {
    passive: true,
  });
  document.addEventListener('scroll', stickMenuCheck);

  window.addEventListener('resize', stickMenuCheck, {
    passive: true,
  });
}

function stickMenuCheck() {
  console.log('in check');
  const offset = $('header .main-menu')[0].offsetTop;
  headerHeight = $stickyHeader.outerHeight();
  // if menu if sticky and over content, there doesn't need to be an offset
  if ($stickyHeader.hasClass('site-header--absolute')) {
    headerHeight = 0;
  }
  const scrolledOffset = $(document).scrollTop();
  if (window.innerWidth >= menuBreakpoint) {
    // unset margin if coming from below breakpoint to above
    if (belowBreakpoint) {
      $mainSection.css('margin-top', '');
    }
    belowBreakpoint = false;

    // check if we need to stick or unstick menu
    if (scrolledOffset > offset && !stuck) {
      // stick it
      stickMenu(offset);
    } else if (scrolledOffset < offset && stuck) {
      // unstick it
      unstickMenu();
    }
  } else {
    // when under menu breakpoint
    if (stuck) {
      unstickMenu();
      stuck = false;
    }

    belowBreakpoint = true;
    $mainSection.css('margin-top', headerHeight);
  }
}

function stickMenu(offset) {
  stuck = true;
  $stickyHeader.addClass('stuck');
  $stickyHeader.css('top', `-${offset + 1}px`);
  $mainSection.css('margin-top', headerHeight);
}

function unstickMenu() {
  $stickyHeader.removeClass('stuck');
  $stickyHeader.css('top', '');
  $mainSection.css('margin-top', '');
  stuck = false;
}




//----------------------------------------
// Functions for the "Mega" Menu
//----------------------------------------

let mainMenuOpen = false;
const $topLevelNavContainer = $('.site-header .main-menu');
const $topLevelNavBackground = $('.main-menu-bg-container');
const $mainMenuTriggers = $('.main-menu .menu-level-1 > li.is-parent');

// Prevent the 2nd level "dummy" menu items from being clicked on and closing the mega menus
// from Brian
$('#block-altos-child-main-menu > ul > li.is-parent > ul > li > span').click(false);

// function to grab height of top bar and set the appropriate height of the menu backgrounds
function grabMainMenuHeight() {
  let mainMenuHeight = $('header').outerHeight();

  $topLevelNavBackground.css({
    'height': 'calc(100vh - ' + mainMenuHeight + 'px)',
    'top': mainMenuHeight
  });
}

// function to handle the opening of the menu's background
function openMainMenu() {
  //$(this).addClass('opened-menu');
  $('#main-page-wrapper').addClass('has-mainmenu-open');
  $topLevelNavBackground.slideDown(300);
  $('ul.menu-level-2').prepend('<li class="faux-li-close"><a href="#"><span class="icon-close"></span> Close Menu</a></li>');
  mainMenuOpen = true;
  return false;
}

// function to handle the closing of the menu's background
function closeMainMenu() {
  $mainMenuTriggers.removeClass('opened-menu');
  $('#main-page-wrapper').removeClass('has-mainmenu-open');
  $topLevelNavBackground.slideUp(300).removeClass (function (index, className) {
    return (className.match (/\bbg-image-\S+/g) || []).join(' ');
  });
  $('ul.menu-level-2 li.faux-li-close').remove();
  mainMenuOpen = false;
  return false;
}

// setup the main toggle function
function toggleMainMenuBg() {
  if (window.innerWidth > menuBreakpoint) {

    $mainMenuTriggers.off(); // prevent duplicate bindings

    $mainMenuTriggers.on('click', function(e) {

      if (mainMenuOpen == false) {
        // menu is not open
        $(this).addClass('opened-menu');
        var bgImageClass = 'bg-image-' + $(this).children('span').text().toLowerCase().replace(/\s+/g, '-');
        $topLevelNavBackground.addClass(bgImageClass);
        openMainMenu();
      } else if ($(this).hasClass('opened-menu') && mainMenuOpen == true) {
        // the currently opened menu item is clicked, so close the menu
        closeMainMenu();
      } else {
        // a different menu item is clicked, so transition to that
        $(this).addClass('opened-menu').siblings().removeClass('opened-menu');
        $topLevelNavBackground.removeClass (function (index, className) {
          return (className.match (/\bbg-image-\S+/g) || []).join(' ');
        });
        var bgImageClass = 'bg-image-' + $(this).children('span').text().toLowerCase().replace(/\s+/g, '-');
        $topLevelNavBackground.addClass(bgImageClass);
      }

    });

    // Jobin testing
    $('body').on('click', '.header__inner', function(e) {
      // if the target click is anywhere on the body that is NOT within the menu area, then do nothing with the function
      if (e.target !== this) {
        return;
      }
      // otherwise, close the menu
      closeMainMenu();
    });

  } else {
    $mainMenuTriggers.off(); // unset the function if below menuBreakpoint
    closeMainMenu(); // make sure that the menu gets closed if open when sizing down to mobile
  }
}


// Run the functions immediately and then again after window resize
if (window.innerWidth > menuBreakpoint) {
  toggleMainMenuBg();
  grabMainMenuHeight();
}
$(window).resize(toggleMainMenuBg);
$(window).resize(grabMainMenuHeight);




//----------------------------------------
// Donations Button Dropdown Menu
//----------------------------------------

let donateOptionsOpen = false;

// function toggleDonationOptions() {
//   $('.donations-btn').off('click'); // Prevent duplicate bindings
//   $('.donations-dropdown').unbind('mouseenter mouseleave'); // Prevent duplicate bindings

//   if (window.innerWidth < menuBreakpoint && window.innerWidth > 480) {
//     // Handle the touch/click effect for tablet/large mobile users
//     $('.donations-btn').on('click', function(e) {
//       e.preventDefault();
//       if (!donateOptionsOpen) {
//         $('.donations-options-wrapper').slideDown(300);
//         donateOptionsOpen = true;
//       } else {
//         $('.donations-options-wrapper').slideUp(300);
//         donateOptionsOpen = false;
//       }
//     });
//   } else if (window.innerWidth < 480) {
//     // Move the element to be under the mobile search
//     $('.donations-btn').appendTo('.main-menu').wrap('<div class="mobile-donations-cta"></div>');


//   } else {
//     // Otherwise, handle the hover effect for desktop users
//     $('.donations-dropdown').hover(function() {
//       $(this).children('.donations-options-wrapper').stop('fx', true).slideToggle(300);
//     });
//   }

// }

// Run the function immediately and then again after window resize
// toggleDonationOptions();
// $(window).resize(toggleDonationOptions);

